import request from "root/js/request";

const getAbcEconomicLogicPies = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  subject,
  category_id__in,
  brand_id__in,
  subject_id__in = subject, // для обратной совместимости
  product_id__in,
  barcode__in,
  analyze_by,
  labels,
  xyz_labels,
  group_by,
}) => {
  const response = await request({
    url: "/analytics/abc_analysis_pie_data/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      subject_id__in,
      product_id__in,
      barcode__in,
      analyze_by,
      labels,
      xyz_labels,
      group_by,
    },
  });
  return response.data;
};

export { getAbcEconomicLogicPies };
